import { IParcelasPagar, Pagamentos } from '../../modules/contas-pagar/models/parcelas.model';
import { IParcelasReceber } from '../../modules/contas-receber/models/parcelas.model';
import { Utils } from '../helpers/utils';
import { convertTimeZone, zeroHours } from './date';

/**
 * Verifica os dias de tolerância e se caso a parcela estiver atrasada o juros é calculado
 * @param parcela que irá ser verificado para calcular o juros
 * @param diasTolerancia dias de tolerância cadastrado para o domínio
 * @param juros taxa de juros cadastrado para o domínio
 * @returns
 */
export function recalculateJuros(parcela, juros?: number, diasTolerancia?: number, type?: string){
  let vencimentoAux = convertTimeZone(new Date(parcela.vencimento));
  let presentDay = zeroHours(convertTimeZone(new Date()));
  let valorAux = parcela.valor
  let diferencaDias = 0
  for(let aux in parcela.pagamentos){
    let dateVencimento = new Date(vencimentoAux);
    let datePagto = convertTimeZone(new Date(parcela.pagamentos[aux].data_hora))
    diferencaDias = Math.round((datePagto.getTime() - dateVencimento.getTime())/(1000*3600*24))
    let resultObject = {valor_juros: 0, juros: 0}
    type === 'receber' ?
      resultObject = calculoJuros(diferencaDias > diasTolerancia && diferencaDias > 0, vencimentoAux, valorAux, juros, datePagto) as any
    : resultObject = calculoJurosMulta(diferencaDias > 0, vencimentoAux, valorAux, parcela.valor_juros_diario, datePagto) as any
    parcela.valor_juros = Number(resultObject.valor_juros)
    parcela.valor_juros -= parcela.pagamentos[aux].valor
    parcela.juros = resultObject.juros === undefined ? 0 : Number(resultObject.juros)
    diferencaDias = diferencaDias < 0 ? diferencaDias * (-1) : diferencaDias;
    parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
    valorAux = parcela.valor_juros
    vencimentoAux = diferencaDias <= 0 ? vencimentoAux : datePagto
  }
  diferencaDias = Math.round((presentDay.getTime() - vencimentoAux.getTime())/(1000*3600*24))
  let resultObject = {valor_juros: 0, juros: 0}
  type === 'receber' ?
    resultObject = calculoJuros(diferencaDias > diasTolerancia && diferencaDias > 0, vencimentoAux, valorAux, juros, presentDay) as any
  : resultObject = calculoJurosMulta(diferencaDias >= 0, vencimentoAux, valorAux, parcela.valor_juros_diario, presentDay) as any
  parcela.valor_juros = Utils.converteABNT(Number(resultObject.valor_juros),2);
  parcela.juros = resultObject.juros === undefined ? 0 : Utils.converteABNT(Number(resultObject.juros),2);
  diferencaDias = diferencaDias < 0 ? diferencaDias * (-1) : diferencaDias;
  parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
  return parcela
}

/**
 * Verifica os dias de tolerância e se caso a parcela estiver atrasada o juros é calculado
 * @param parcela parcela atual
 * @param diasTolerancia dias de tolerância cadastrado para o domínio
 * @param juros taxa de juros cadastrado para o domínio
*/
export function  verificarJuros(parcela: IParcelasReceber, diasTolerancia : number, juros : number){
  const dataAtual = zeroHours(convertTimeZone(new Date()));
  let dateVencimento = convertTimeZone(new Date(parcela.vencimento))
  let diferencaDias = Math.round((dataAtual.getTime() - dateVencimento.getTime())/(1000*3600*24))
  if(diferencaDias <= diasTolerancia){
    parcela.valor_juros = Utils.converteABNT(parcela.valor,2);
    parcela.valor_inicial = Utils.converteABNT(parcela.valor,2);
    parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
  }else{
    parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
    parcela.juros = Utils.converteABNT((Number(parcela.valor) *  ((juros/100)/30) * (diferencaDias)),2);
    parcela.valor_juros = Utils.converteABNT((Number(parcela.valor) + parcela.juros),2);
    parcela.valor_inicial = Utils.converteABNT(parcela.valor_juros,2);
  }
  return parcela
}

/**
 * Verifica os dias de tolerância e se caso a parcela estiver atrasada o juros é calculado
 * @param parcela parcela atual
*/
export function  verificarJurosMulta(parcela: IParcelasPagar){
  const dataAtual = zeroHours(convertTimeZone(new Date()));
  let dateVencimento = convertTimeZone(new Date(parcela.vencimento))
  let diferencaDias = Math.round((dataAtual.getTime() - dateVencimento.getTime())/(1000*3600*24))
  if((diferencaDias * (-1)) > 0){
    parcela.valor_juros = Utils.converteABNT(parcela.valor,2);
    parcela.valor_inicial = Utils.converteABNT(parcela.valor,2);
    parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
  }else{
    parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1)
    parcela.valor_juros = Utils.converteABNT(Number(parcela.valor + (parcela.valor_juros * diferencaDias)),2);
    parcela.valor_inicial = Utils.converteABNT(parcela.valor_juros,2);
  }
  return parcela
}

  /**
   * Ordenar por vencimento as pagamentos
   * @param pagamentos
   * @returns
   */
  export function ordenarPagamentos(pagamentos: Pagamentos[]): Pagamentos[] {
    return pagamentos.sort(function(a, b) {
      let dataPagtoPre = new Date(a.data_hora);
      let dataPagtoPos = new Date(b.data_hora);
      return dataPagtoPre.getTime() > dataPagtoPos.getTime()
        ? 1
        : dataPagtoPos.getTime() > dataPagtoPre.getTime()
        ? -1
        : 0;
    });
  }

/**
 * Verifica se a parcela está atrasada com base nos dias de tolerância, se ela não estiver atrasada não precisa
 * recalcular o juros com base nos pagamentos
 * @param parcela
 * @param diasTolerancia
 * @returns
 */
export function checkAtrasada(parcela, diasTolerancia: number){
  let vencimentoAux = convertTimeZone(new Date(parcela.vencimento))
  let dataAtual = zeroHours(convertTimeZone(new Date()));
  let diferencaDias = 0
  // if(parcela.pagamentos.length === 0){
    diferencaDias = Math.round((dataAtual.getTime() - vencimentoAux.getTime())/(1000*3600*24));
    parcela.dias_atraso = diferencaDias <= 0 ? diferencaDias * (-1) : diferencaDias * (-1);
    // parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1);
  // }else{
  //   parcela.pagamentos.forEach(pagto => {
  //     let dateVencimento = new Date(vencimentoAux);
  //     let datePagto = convertTimeZone(new Date(pagto.data_hora))
  //     diferencaDias = Math.round((datePagto.getTime() - dateVencimento.getTime())/(1000*3600*24))
  //     parcela.dias_atraso = diferencaDias <= 0 ? 0 : diferencaDias * (-1);
  //     vencimentoAux = datePagto;
  //   })
  //   diferencaDias = Math.round((dataAtual.getTime() - vencimentoAux.getTime())/(1000*3600*24));
  //   parcela.dias_atraso = diferencaDias <= 0 || diferencaDias < diasTolerancia ? 0 : diferencaDias * (-1);
  // }
  return parcela
}

/**
 * Calcular o novo valor do juros no valor total da parcela
 * @param calculoJuros booleana para verificar se precisa recalcular o juros
 * @param vencimento vencimento atual da parcela
 * @param valor valor da parcela
 * @param juros taxa de juros
 * @param dataAux data de pagamento da parcela
 * @returns
 */
export function calculoJuros(calculoJuros: boolean, vencimento: Date, valor: number, juros: number, dataAux: Date){
  if(calculoJuros){
    let dateVencimento = new Date(vencimento)
    let diferencaDias = Math.round((dataAux.getTime() - dateVencimento.getTime())/(1000*3600*24))
    juros = valor * ((juros/100)/30) * diferencaDias;
    valor += juros;
    return {valor_juros: valor , juros}
  }else{
    return {valor_juros: Utils.converteABNT(valor,2)}
  }
}

export function calculoJurosMulta(calculoJurosMulta: boolean, vencimento: Date, valor: number, juros: number, dataAux: Date){
  if(calculoJurosMulta){
    let dateVencimento = new Date(vencimento)
    let diferencaDias = Math.round((dataAux.getTime() - dateVencimento.getTime())/(1000*3600*24))
    juros = juros * diferencaDias
    valor += juros;
    return {valor_juros: valor , juros}
  }else{
    return {valor_juros: Utils.converteABNT(valor,2)}
  }
}
/**
 * Mapeia o array de pagamentos da parcela e sumariza os valores
 * @param id da parcela
 * @param pagamentos
 * @returns o valor total dos pagamentos
 */
export function verificarPagamentos(id : string, pagamentos, type: string){
  let valor = 0
  for(let aux in pagamentos){
    if(type === 'receber'){
      if(pagamentos[aux].conta_receber_parcela_id === id && pagamentos[aux].valor > 0)
          valor += pagamentos[aux].valor
    }else{
      if(pagamentos[aux].conta_pagar_parcela_id === id && pagamentos[aux].valor > 0)
          valor += pagamentos[aux].valor
    }
  }
  return Utils.converteABNT(valor,2);
}
